import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Check, Sparkles } from 'lucide-react';
export function SolutionSection() {
  return <section className="w-full px-4 py-12 max-w-2xl mx-auto" data-id="element-180">
      <FadeIn data-id="element-181">
        <div className="text-center mb-12" data-id="element-182">
          <h2 className="text-2xl md:text-3xl font-bold text-[#2D2A26] mb-2" data-id="element-183">
            The simplest way to break the loop
          </h2>
          <p className="text-xl text-[#2D2A26]/70 font-serif italic" data-id="element-184">
            (without forcing bravery)
          </p>
        </div>

        <div className="prose-letter space-y-6 text-[#2D2A26] mb-12" data-id="element-185">
          <p data-id="element-186">You don't need a dramatic workout.</p>
          <p data-id="element-187">
            You need a short, safe, repeatable routine that teaches your body to
            stabilize while moving.
          </p>
          <p data-id="element-188">That's what this guide is.</p>
        </div>
      </FadeIn>

      <FadeIn delay={0.2} data-id="element-189">
        <div className="bg-[#7B9E6B]/10 p-8 md:p-10 rounded-2xl border border-[#7B9E6B]/20 mb-16" data-id="element-190">
          <div className="text-center mb-8" data-id="element-191">
            <span className="text-sm font-bold tracking-widest text-[#7B9E6B] uppercase mb-2 block" data-id="element-192">
              Introducing
            </span>
            <h3 className="text-2xl md:text-4xl font-bold text-[#2D2A26] font-serif leading-tight" data-id="element-193">
              The "No-Fall Confidence" <br data-id="element-194" />
              <span className="text-[#7B9E6B]" data-id="element-195">
                14-Day Micro-Balance Plan
              </span>{' '}
              <span className="text-lg align-top text-[#2D2A26]/60" data-id="element-196">(65+)</span>
            </h3>
          </div>

          <ul className="space-y-4 mb-0" data-id="element-197">
            {['A 10-minute-a-day, chair-supported routine you can do at home.', 'No gym.', 'No floor work required.', 'No complicated equipment.', "No long videos you'll never finish."].map((item, i) => <li key={i} className="flex items-start text-lg text-[#2D2A26]" data-id="element-198">
                <Check className="w-6 h-6 text-[#7B9E6B] mr-3 flex-shrink-0 mt-0.5" data-id="element-199" />
                {item}
              </li>)}
          </ul>
        </div>
      </FadeIn>

      <FadeIn delay={0.3} data-id="element-200">
        <div className="mb-16" data-id="element-201">
          <h3 className="text-xl md:text-2xl font-bold text-[#2D2A26] mb-6 flex items-center" data-id="element-202">
            <Sparkles className="w-6 h-6 text-[#FF5A5F] mr-3" data-id="element-203" />
            The Unique Mechanism: Dynamic Balance Micro-Doses
          </h3>

          <div className="prose-letter space-y-6 text-[#2D2A26]" data-id="element-204">
            <p data-id="element-205">Most "balance routines" are either:</p>
            <ul className="list-disc pl-6 space-y-2 marker:text-[#FF5A5F]" data-id="element-206">
              <li data-id="element-207">too advanced</li>
              <li data-id="element-208">too long</li>
              <li data-id="element-209">too vague ("practice standing on one foot")</li>
              <li data-id="element-210">or so random you can't tell if you're improving</li>
            </ul>

            <p data-id="element-211">
              This plan uses{' '}
              <strong className="text-[#7B9E6B]" data-id="element-212">
                Dynamic Balance Micro-Doses
              </strong>
              : tiny daily drills that mimic the exact moments that trigger
              wobble: turning, stepping, reaching, backing up.
            </p>

            <p data-id="element-213">
              And because you do them daily, your nervous system adapts fast.
            </p>
          </div>
        </div>
      </FadeIn>

      <FadeIn delay={0.4} data-id="element-214">
        <div className="bg-white p-8 rounded-2xl shadow-sm border border-[#2D2A26]/5" data-id="element-215">
          <h3 className="text-xl font-bold text-[#2D2A26] mb-4" data-id="element-216">
            The part most programs miss: proof
          </h3>

          <div className="prose-letter space-y-4 text-[#2D2A26]" data-id="element-217">
            <p data-id="element-218">Motivation is unreliable.</p>
            <p data-id="element-219">So this plan gives you:</p>
            <ul className="space-y-3" data-id="element-220">
              <li className="flex items-start" data-id="element-221">
                <span className="w-1.5 h-1.5 bg-[#2D2A26] rounded-full mt-2.5 mr-3 flex-shrink-0" data-id="element-222" />
                <span data-id="element-223">
                  a <strong data-id="element-224">Steadiness Score</strong> baseline test (simple,
                  safe, supported)
                </span>
              </li>
              <li className="flex items-start" data-id="element-225">
                <span className="w-1.5 h-1.5 bg-[#2D2A26] rounded-full mt-2.5 mr-3 flex-shrink-0" data-id="element-226" />
                <span data-id="element-227">
                  a <strong data-id="element-228">daily confidence tracker</strong> (so progress
                  becomes obvious)
                </span>
              </li>
            </ul>
            <p className="font-medium mt-4" data-id="element-229">
              Not "positive thinking." Evidence.
            </p>
          </div>
        </div>
      </FadeIn>
    </section>;
}